<template>
	<div class="section row2 clear">
		<h2 class="fl" v-html="$i18nUtil.trans('message.HomeContents.006','최근업데이트<br />과제')"></h2>
		<div class="fr nodata" v-if="projectList.length === 0">
			<div v-if="isInternalUser">
				<div class="txt">{{$i18nUtil.trans("message.HomeContents.002","과제를 생성하여 체계적으로 업무를 관리해보세요.")}}</div>
				<button
					type="button"
					class="btn-primary-small black"
					@click="addProject"
				>
					{{ $i18nUtil.trans("button.project.add", "과제 추가") }}
				</button>
			</div>
			<div v-else>
				<div class="txt">{{$i18nUtil.trans("search.002","참여중인 과제가 없습니다.")}}</div>
			</div>
		</div>
		<div class="tab_ty2 fr" id="tabsTy2" v-else>
			<ul class="tab-menu">
				<li
					v-for="(project, index) in projectList"
					:key="project.projectId"
					v-bind:class="{ active: currentTab === index }"
				>
					<button
						type="button"
						class="ell-singleline"
						@click="getCategoryList(project, index)"
						@mouseover="mouseEvt(true, project, $event, 'project')"
						@mouseleave="mouseEvt(false, project, null, 'project')"
					>
						{{ project.projectName }}
					</button>
					<div class="tooltip-b tl small" :id="project.projectId+'_tooltip'" style="display:none; z-index: 10; position: absolute; word-break: break-all;">
						{{ project.projectName }}
					</div>
				</li>
			</ul>
			<div class="tab-content">
				<!-- <div v-show="currentTab == 0"> -->
				<div>
					<div class="clear" v-if="categoryList.length === 0">
						<div class="nodata">
							<div class="txt" v-html="$i18nUtil.trans('message.HomeContents.003','과제와 보드를 추가해 <br />업무를 다양하게 관리해보세요.')"></div>
							<button
								type="button"
								class="btn-primary-small black"
								@click="registFolder"
							>
								{{ $i18nUtil.trans("entity.category.depth2.add","과정 추가") }}
							</button>
						</div>
					</div>
					<div class="clear" v-if="categoryList.length > 0">
						<div
							class="category_area"
							v-for="(category, index) in categoryList"
							:key="category.categoryMid"
						>
							<div class="tit ell-singleline" style="display:block;">
								{{ category.categoryName }}
							</div>
							<ul :id="category.categoryMid" v-if="index == 0 && fBoardList.length != 0">
								<li style="word-break: break-all;"
									v-for="paper in fBoardList"
									:key="paper.paperId"
								>
									<div
											:class="
												'ico-txt-' +
												(paper.paperStatus === 'GOOD'
													? 'evaluate-good'
													: paper.paperStatus === 'SO'
													? 'evaluate-so'
													: paper.paperStatus === 'DELAY'
													? 'evaluate-delay'
													: 'evaluate-exceeded')
											"
											@click="goBoard(paper)"
											style="cursor: pointer"
											@mouseover="mouseEvt(true, paper, $event, 'paper')"
											@mouseleave="mouseEvt(false, paper, null, 'paper')"
										>
											{{ paper.paperTitle }}
										</div>
										<div class="tooltip-b tl small backwards" :id="paper.categoryMid+'_'+paper.paperId+'_tooltip'" style="display:none; z-index: 10; position:absolute;">
											{{ paper.paperTitle }}
										</div>
									<!-- <router-link
										:to="{
											name: 'board',
											params: { paperId: paper.paperId },
										}"
									>
										<div
											:class="
												'fl ico-txt-' +
												(paper.paperStatus === 'GOOD'
													? 'evaluate-good'
													: paper.paperStatus === 'SO'
													? 'evaluate-so'
													: paper.paperStatus === 'DELAY'
													? 'evaluate-delay'
													: 'evaluate-exceeded')
											"
										>
											{{ paper.paperTitle }}
										</div>
									</router-link> -->
									<div class="fr part-member-num">
										<div class="droplayer relative right">
											<UserInfo
												:userId="paper.regUserId"
												:userName="paper.regUserName"
												:userNameEn="paper.regUserNameEn"
												:userCount="paper.paperUserCount"
												:paperId="paper.paperId"
											/>
										</div>
									</div>
								</li>
							</ul>
							<button
								type="button"
								class="btn-addboard"
								@click="addBoard(category)"
								v-if="index == 0"
							>
								{{ $i18nUtil.trans("button.paper.add", "보드 추가") }}
							</button>
							<ul :id="category.categoryMid" v-if="index == 1 && sBoardList.length > 0">
								<li
									v-for="paper in sBoardList"
									:key="paper.paperId"
								>
									<div
										:class="
											'fl ico-txt-' +
											(paper.paperStatus === 'GOOD'
												? 'evaluate-good'
												: paper.paperStatus === 'SO'
												? 'evaluate-so'
												: paper.paperStatus === 'DELAY'
												? 'evaluate-delay'
												: 'evaluate-exceeded')
										"
										@click="goBoard(paper)"
										style="cursor: pointer"
										@mouseover="mouseEvt(true, paper, $event, 'paper')"
										@mouseleave="mouseEvt(false, paper, null, 'paper')"
									>
										{{ paper.paperTitle }}
									</div>
									<div class="tooltip-b tl small backwards" :id="paper.categoryMid+'_'+paper.paperId+'_tooltip'" style="display:none; z-index: 10; position:absolute;">
										{{ paper.paperTitle }}
									</div>
									<!-- <router-link
										:to="{
											name: 'board',
											params: { paperId: paper.paperId },
										}"
									>
										<div
											:class="
												'fl ico-txt-' +
												(paper.paperStatus === 'GOOD'
													? 'evaluate-good'
													: paper.paperStatus === 'SO'
													? 'evaluate-so'
													: paper.paperStatus === 'DELAY'
													? 'evaluate-delay'
													: 'evaluate-exceeded')
											"
										>
											{{ paper.paperTitle }}
										</div>
									</router-link> -->
									<div class="fr part-member-num">
										<div class="droplayer relative right">
											<UserInfo
												:userId="paper.regUserId"
												:userName="paper.regUserName"
												:userNameEn="paper.regUserNameEn"
												:userCount="paper.paperUserCount"
												:paperId="paper.paperId"
											/>
										</div>
									</div>
								</li>
							</ul>
							<button
								type="button"
								class="btn-addboard"
								@click="addBoard(category)"
									v-if="index == 1"
							>
								{{ $i18nUtil.trans("button.paper.add", "보드 추가") }}
							</button>
						</div>
						<div class="category_area" v-if="categoryList.length === 1">
							<div class="nodata">
								<div class="txt" v-html="$i18nUtil.trans('message.HomeContents.003','과제와 보드를 추가해 <br />업무를 다양하게 관리해보세요.')"></div>
								<button
									type="button"
									class="btn-primary-small black"
									@click="registFolder"
								>
									{{ $i18nUtil.trans("entity.category.depth2.add","과정 추가") }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modals-container
      @registBoard="registBoard"
      @add-category="addcategory"
      @refreshHomeContents="$emit('initNewWorkList')"
    ></modals-container>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";
import RegistCategoryModal from "@/components/cowork/general/project/modal/RegistCategoryModal";
import CreateProject from "@/components/cowork/general/project/modal/CreateProject";
import UserInfo from "@/components/cowork/common/user/UserInfo";

export default {
	props: [
		'projectList',
		'browser'
	],
	components: {
		UserInfo
	},
	data() {
		return {
			currentTab: 0,
			fBoardList: [],
      sBoardList: [],
			selectedProject: null,
      selectedProjectId: null,
      selectedProjectName: null,
			parentCategoryMid: null,
			categoryList: [],
			toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
		}
	},
	computed: {
    ...mapState("introInfo", ["isInternalUser"]),
  },
	methods: {
		...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
		...mapActions("modals", ["showModal"]),
		...mapActions("modals", ["showToast"]),

		async getCategoryList(project, index) {
      let obj = this;
      obj.fBoardList = [];
      obj.sBoardList = [];
      obj.currentTab = index;
      obj.selectedProject = project;
      obj.selectedProjectId = project.projectId;
      obj.selectedProjectName = project.projectName;
      let reqData = {
        url: "/api/copaper/category/getCategoryTwoList",
        method: "post",
        params: {
          projectId: project.projectId,
        },
      };
      await obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result != null) {
              obj.categoryList = res.result.categoryList;
              obj.parentCategoryMid = res.result.parentCategoryMid;
              if (obj.categoryList !== null && obj.categoryList.length > 0) {
                let cnt = 0;
                let axiosArr = [];
                let boardArr = [];

                obj.categoryList.forEach((category) => {
                  let boardReqData = {
                    url: "/api/copaper/paper/getCategoryPaperList",
                    method: "post",
                    params: {
                      projectId: category.projectId,
                      categoryMid: category.categoryMid,
                    },
                  };
                  axiosArr.push(
                    obj.$axios.post(boardReqData.url, boardReqData.params)
                  );
                });
                if (axiosArr.length > 0) {
                  obj.$axios
                    .all(axiosArr)
                    .then(
                      obj.$axios.spread((...responses) => {
                        if (responses !== null && responses.length > 0) {
                          responses.forEach((item, index) => {
                            let list = item.data.result.paperList.content;
                            if (index === 0) {
                              list.forEach((paper, index) => {
                                if (index < 3) {
                                  obj.fBoardList.push(paper);
                                }
                              });
                            } else {
                              list.forEach((paper, index) => {
                                if (index < 3) {
                                  obj.sBoardList.push(paper);
                                }
                              });
                            }
                          });
                        }
                      })
                    )
                    .catch((errors) => {
                      console.log(errors);
                    });
                }
              }

              // obj.categoryList.forEach(element => {
              //     obj.getBoardList(element.categoryMid, element.projectId)
              // });
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
		/* 과체 추가 */
    addProject() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.CreateProject.001","과제 등록"),
        width: "800px",
        // height: "743px",
        obj: this.$modal,
        listType: this.listType,
        component: CreateProject,
      };
      this.showModal(modalInfo);
    },
		registFolder() {
      let projectInfo = this.selectedProject;
      const modalInfo = {
        title: this.$i18nUtil.trans("title.RegistCategoryModal.001","과정 추가"),
        name: "registFolder",
        method: "post",
        width: "500px",
        // height: "300px",
        obj: this.$modal,
        component: RegistCategoryModal,
        groupId: projectInfo.groupId,
        parentCategoryMid: this.parentCategoryMid,
        projectId: projectInfo.projectId,
        regUserId: projectInfo.regUserId,
      };
      this.showModal(modalInfo);
    },
		addBoard(category) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/paper/getGeneratedPaperId",
        method: "post",
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          let errorCode = res.errorCode;
          let addPaperId = res.result;
          const modalInfo = {
            title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
            name: "registBoard",
            method: "post",
            width: "800px",
            // height: "493px",
            obj: obj.$modal,
            paperTitle: "",
            contentPath: "",
            component: RegistBoardModal,
            paperId: addPaperId,
            groupId: category.groupId,
            projectId: obj.selectedProjectId,
            projectName: obj.selectedProjectName,
            categoryMid: category.categoryMid,
            parentCategoryMid: category.parentCategoryMid,
          };

          obj.showModal(modalInfo);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
		addcategory(param, parentCategory) {
      let obj = this;
      let reqData = {};
      reqData.params = param;
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/saveCategory";
      reqData.method = "post";
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          //this.setDashBoard(this.projectId);
          if (res.errorCode != null) {
            if (res.errorCode == "DUPLICATE_CATEGORY_NAME") {
              obj.toastInfo.message = obj.$i18nUtil.trans("UB024");
              obj.showToast(obj.toastInfo);
              return;
            }
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB022", "과정이 추가되었습니다.");
            obj.showToast(obj.toastInfo);
            let path = "/general/dashboard/" + obj.selectedProjectId;
            obj.$router.push(path);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
		registBoard(_data) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/paper/addPaper",
        method: "post",
        params: {
          paperTitle: _data.paperTitle,
          paperId: _data.paperId,
          groupId: _data.groupId,
          categoryMid: _data.categoryMid,
          contentPath: _data.contentPath,
          docGrade: _data.docGrade,
          blockType: "CONTENT",
          tagList: _data.tagList,
          link: "/general/board/" + _data.paperId,
        },
      };
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.hideLoadingbar();
          if (res.errorCode != null) {
            return;
          }
          if (res.result !== null) {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB036", "보드가 저장되었습니다.");
            obj.showToast(obj.toastInfo);
            let path = "/general/board/" + res.result;
            obj.$router.push(path);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
		goBoard(paper) {
      this.$router.push({
        name: 'board',
        params: { paperId: paper.paperId },
      })
    },
		/* 툴팁 */
    mouseEvt(flag, item, event, type) {
      let tooltipId = type === 'project' ? item.projectId+'_tooltip': item.categoryMid+'_'+item.paperId+'_tooltip';
      if(flag) {
        // 말줄임(...) css 적용 여부 체크 (boolean)
        let val = type === 'project' ? 
          this.$tooltip.hasOverflownWidthRemoveClass(event.target, "ell-singleline") 
            : this.$tooltip.hasOverflownWidth(event.target);
        if(val) {
          if(type === 'paper') {
            let left = event.target.offsetLeft;
            let location = event.target.getBoundingClientRect();
            let locY = window.scrollY || window.pageYOffset; // IE 호환
            let loc = location.top + locY - 27;
            document.getElementById(tooltipId).style.top = loc + 'px';
            if(this.browser === 'ie') {
              document.getElementById(tooltipId).style.left = left + 'px';
            }
          }
          document.getElementById(tooltipId).style.display = 'block';
        }else{
          document.getElementById(tooltipId).style.display = 'none';
        };
      }else{
        document.getElementById(tooltipId).style.display = 'none';
      }
    },
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/home/base/UpdateWorkspace.vue